module.exports = __webpack_public_path__ + "0a846f4ac82561d8d5d88f50a1aeb9b5.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics1/13.png
// module id = 281
// module chunks = 0